import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { SetEthanContext } from 'app/state/ethan/ethan.action';
import { CompanyDetailsComponent } from './details/details.component';

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateCompaniesDetails {
  constructor(private store: Store) {}
  canDeactivate(
    component: CompanyDetailsComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Get the next route
    let nextRoute: ActivatedRouteSnapshot = nextState.root;
    while (nextRoute.firstChild) {
      nextRoute = nextRoute.firstChild;
    }

    this.store.dispatch(new SetEthanContext(null, null));

    // If the next state doesn't contain '/Companies'
    // it means we are navigating away from the
    // Companies app
    if (!nextState.url.includes('/companies')) return true;

    // If we are navigating to another company...
    if (nextRoute.paramMap.get('id')) return true;
    else return true;
  }
}
